const binding = { modules: {}, dataActions: {} };

    (binding.modules['product-feature'] = {
        c: () => require('partner/modules/product-feature/product-feature.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'product-feature',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/product-feature'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|product-feature|product-feature'] = {
                c: () => require('partner/modules/product-feature/product-feature.view.tsx'),
                cn: '__local__-__local__-product-feature'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };